import React from 'react';
import { CheckCircle } from '@mui/icons-material';
import useTranslate from '../../../../../customHooks/useTranslate';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import IconButton from '../../../../../muiComponents/IconButton';
import Tag from '../../../../../muiComponents/Tag';
import Icon from '../../../../../muiComponents/Icon';
import Button from '../../../../../muiComponents/Button';
import {
    ZitoneoQualityLevel,
    zitoneoQualityLevelColor,
} from '../../../utils/zitoneoContentScoreUtils';

interface ServiceItemHeaderProps {
    name: string;
    isNewService: boolean;
    instanceCount: number;
    attributesAreLoading: boolean;
    attributesFilled: number;
    attributesAvailable: number;
    contentQualityLevel: ZitoneoQualityLevel;
    hasExceptions?: boolean;
    isExpanded: boolean;
    onToggle: () => void;
    onDelete?: () => void;
}

const ServiceItemHeader = ({
    name,
    isNewService,
    instanceCount,
    attributesAreLoading,
    attributesFilled,
    attributesAvailable,
    contentQualityLevel,
    hasExceptions = false,
    isExpanded,
    onToggle,
    onDelete,
}: ServiceItemHeaderProps) => {
    const translate = useTranslate();

    return (
        <div
            className={`zitoneo-service__header ${
                isExpanded && !attributesAreLoading ? 'border-color-bottom' : ''
            }`}
        >
            <div className='flex flex-align-center gap-20'>
                <div className='flex flex-align-center gap-10'>
                    <CheckCircle color='success' fontSize='small' />
                    <label className='zitoneo-service__label'>{name}</label>
                </div>
                {isNewService && (
                    <Tag
                        variant='outlined'
                        color='cyan'
                        text={translate('new')}
                    />
                )}
                {instanceCount > 1 && (
                    <Tag
                        variant='outlined'
                        color='grey'
                        text={`x${instanceCount}`}
                    />
                )}
            </div>
            <div className='zitoneo-service-header__actions'>
                {attributesAreLoading ? (
                    <LoadingPlaceholder width={100} height={20} />
                ) : (
                    <>
                        {hasExceptions && (
                            <Tag
                                variant='contrast'
                                startIcon='Circle'
                                color='orange'
                                text={translate('errata')}
                                uppercase
                            />
                        )}
                        {onDelete && (
                            <Button
                                startIcon='DeleteOutlined'
                                variant='text'
                                sx={{ color: 'var(--error-400)' }}
                                onClick={onDelete}
                            >
                                {translate('delete')}
                            </Button>
                        )}
                        <div className='flex flex-align-center gap-5'>
                            <Icon
                                iconName='Circle'
                                style={{
                                    color: zitoneoQualityLevelColor[
                                        contentQualityLevel
                                    ],
                                    fontSize: 10,
                                }}
                            />
                            <p>{`${attributesFilled} / ${attributesAvailable} ${translate(
                                'attributes'
                            )}`}</p>
                        </div>
                        <IconButton
                            iconName={isExpanded ? 'ExpandLess' : 'ExpandMore'}
                            onClick={onToggle}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ServiceItemHeader;
